/**
 * Delivery & Services - Pincode check with iThink Logistics API
 * Shows delivery info and complimentary gift when expected_delivery_date max days > 4
 * Auto-adds complimentary gift to cart when gift is visible and user adds product to cart.
 */
(function () {
  // Fetch interceptor: when gift is eligible, add gift variant(s) to cart/add.js requests
  const origFetch = window.fetch;
  window.fetch = function (url, opts) {
    if (!opts || opts.method !== 'POST' || typeof url !== 'string') return origFetch.apply(this, arguments);
    const urlStr = String(url);
    const isCartAdd = urlStr.indexOf('cart/add') !== -1 && urlStr.indexOf('.js') !== -1;
    const giftIds = window.__deliveryComplimentaryGiftVariants;
    const giftEligible = window.__deliveryGiftEligible && Array.isArray(giftIds) && giftIds.length > 0;

    if (!isCartAdd || !giftEligible) return origFetch.apply(this, arguments);

    try {
      const body = typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body || {});
      const parsed = JSON.parse(body);
      let items = parsed.items;
      if (!items || !Array.isArray(items)) {
        if (parsed.id != null) {
          items = [{ id: parsed.id, quantity: parsed.quantity || 1, properties: parsed.properties || {} }];
        } else {
          return origFetch.apply(this, arguments);
        }
      }

      const giftItems = giftIds.map(function (vid) {
        return { id: Number(vid), quantity: 1, properties: { _complimentary_gift: '1' } };
      });
      const merged = items.concat(giftItems);
      const newParsed = Object.assign({}, parsed);
      if (parsed.id != null) {
        newParsed.items = merged;
        delete newParsed.id;
        delete newParsed.quantity;
        delete newParsed.properties;
      } else {
        newParsed.items = merged;
      }
      opts = Object.assign({}, opts, { body: JSON.stringify(newParsed) });
      window.__deliveryGiftEligible = false;
      window.__deliveryComplimentaryGiftVariants = [];
    } catch (e) { /* no-op */ }
    return origFetch.apply(this, arguments);
  };

  // Form submit fallback: intercept product form posts to /cart/add
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.method.toLowerCase() !== 'post' || form.getAttribute('target') === '_blank') return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('cart/add') === -1) return;
    const giftIds = window.__deliveryComplimentaryGiftVariants;
    const giftEligible = window.__deliveryGiftEligible && Array.isArray(giftIds) && giftIds.length > 0;
    if (!giftEligible) return;

    e.preventDefault();
    e.stopPropagation();
    const formData = new FormData(form);
    const items = [];
    const id = formData.get('id') || formData.get('variants[]');
    const qty = parseInt(formData.get('quantity') || 1, 10);
    if (id) items.push({ id: Number(id), quantity: qty });
    if (items.length === 0) return;

    const giftItems = giftIds.map(function (vid) {
      return { id: Number(vid), quantity: 1, properties: { _complimentary_gift: '1' } };
    });
    const merged = items.concat(giftItems);
    window.__deliveryGiftEligible = false;
    window.__deliveryComplimentaryGiftVariants = [];

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const addUrl = root + 'cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: merged })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) {
          window.location.href = root + 'cart';
        } else {
          if (res.data && res.data.description) alert(res.data.description);
          window.location.href = form.action || root + 'cart';
        }
      })
      .catch(function () { window.location.href = form.action || root + 'cart'; });
  }, true);

  function initDeliveryServices() {
    document.querySelectorAll('.delivery-and-services').forEach((block) => {
      const pincodeInput = block.querySelector('[data-delivery-pincode-input]');
      const pincodeDisplay = block.querySelector('[data-delivery-pincode]');
      const checkBtn = block.querySelector('[data-delivery-check-btn]');
      const checkIcon = block.querySelector('[data-delivery-check-icon]');
      const deliveryInfo = block.querySelector('[data-delivery-info]');
      const deliveryDateEl = block.querySelector('[data-delivery-date]');
      const giftBox = block.querySelector('[data-delivery-gift-box]');
      const freeTextEl = block.querySelector('[data-delivery-free-text]');
      const errorEl = block.querySelector('[data-delivery-error]');

      const configEl = block.querySelector('[data-delivery-config]');
      if (!configEl || !pincodeInput || !checkBtn) return;

      let config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.warn('Delivery Services: Invalid config', e);
        return;
      }

      const { apiUrl, accessToken, secretKey, fromPincode, productWeightKg, productMrp, giftVariantIds } = config;
      const hasCredentials = apiUrl && accessToken && secretKey;
      const giftIds = Array.isArray(giftVariantIds) ? giftVariantIds : [];

      pincodeInput.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
      });

      // Initially hide delivery info and gift box until check is done
      if (deliveryInfo) deliveryInfo.style.display = 'none';
      if (checkIcon) checkIcon.style.display = 'none';
      if (giftBox) giftBox.style.display = 'none';

      function hideError() {
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.style.display = 'none';
        }
      }

      function showError(msg) {
        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.style.display = 'block';
        }
      }

      /**
       * Parse expected_delivery_date e.g. "3 to 5 Days" -> 5 (max days)
       */
      function parseMaxDeliveryDays(str) {
        if (!str || typeof str !== 'string') return 0;
        const allNums = str.match(/\d+/g);
        return allNums ? Math.max(...allNums.map(Number)) : 0;
      }

      /**
       * Format EDD date e.g. "2026-02-23" -> "23rd Feb 2026"
       */
      function formatEddDate(dateStr) {
        if (!dateStr) return dateStr;
        const d = new Date(dateStr + 'T12:00:00');
        if (isNaN(d.getTime())) return dateStr;
        const day = d.getDate();
        const suffix = day === 1 || day === 21 || day === 31 ? 'st' : day === 2 || day === 22 ? 'nd' : day === 3 || day === 23 ? 'rd' : 'th';
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${day}${suffix} ${months[d.getMonth()]} ${d.getFullYear()}`;
      }

      function resetToInitial() {
        if (pincodeInput && pincodeDisplay) {
          pincodeInput.style.display = '';
          pincodeInput.value = '';
          pincodeDisplay.textContent = '';
          pincodeDisplay.style.display = 'none';
        }
        if (checkIcon) checkIcon.style.display = 'none';
        if (deliveryInfo) deliveryInfo.style.display = 'none';
        if (freeTextEl) freeTextEl.style.display = 'none';
        if (giftBox) giftBox.style.display = 'none';
        checkBtn.textContent = 'Check Now';
        hideError();
        window.__deliveryGiftEligible = false;
        window.__deliveryComplimentaryGiftVariants = [];
      }

      checkBtn.addEventListener('click', async () => {
        if (checkBtn.textContent === 'Clear') {
          resetToInitial();
          return;
        }

        if (!hasCredentials) {
          showError('Pincode check is not configured. Add iThink API credentials (Access token, Secret key) in block settings.');
          return;
        }

        const toPincode = (pincodeInput?.value || '').trim().replace(/\D/g, '');
        if (toPincode.length !== 6) {
          showError('Please enter a valid 6-digit pincode');
          return;
        }
        hideError();

        checkBtn.disabled = true;
        checkBtn.textContent = 'Checking...';

        try {
          const payload = {
            data: {
              from_pincode: fromPincode || '400097',
              to_pincode: toPincode,
              shipping_length_cms: '10',
              shipping_width_cms: '10',
              shipping_height_cms: '5',
              shipping_weight_kg: String(productWeightKg || 0.5),
              order_type: 'forward',
              payment_method: 'cod',
              product_mrp: String(productMrp || 1200),
              access_token: accessToken,
              secret_key: secretKey,
            },
          };

          const res = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const data = await res.json();
          if (!res.ok) throw new Error(data.message || 'Failed to check delivery');

          if (data.status !== 'success') {
            throw new Error(data.message || 'Delivery check failed');
          }

          // Show current UI: pincode display, check icon, delivery info
          if (pincodeInput && pincodeDisplay) {
            pincodeInput.style.display = 'none';
            pincodeDisplay.textContent = toPincode;
            pincodeDisplay.style.display = '';
          }
          if (checkIcon) checkIcon.style.display = '';

          const expectedDeliveryDate = data.expected_delivery_date || '';
          const eddData = data.edd_data || {};
          let formattedDate = expectedDeliveryDate;
          if (eddData.min_edd && eddData.max_edd) {
            formattedDate = formatEddDate(eddData.min_edd) + ' - ' + formatEddDate(eddData.max_edd);
          } else if (eddData.max_edd) {
            formattedDate = formatEddDate(eddData.max_edd);
          } else if (eddData.min_edd) {
            formattedDate = formatEddDate(eddData.min_edd);
          }

          if (deliveryDateEl) {
            deliveryDateEl.textContent = formattedDate || expectedDeliveryDate;
          }
          if (deliveryInfo) deliveryInfo.style.display = 'flex';

          const maxDays = parseMaxDeliveryDays(expectedDeliveryDate);
          if (giftBox) {
            giftBox.style.display = maxDays > 4 ? 'flex' : 'none';
          }
          if (maxDays > 4 && giftIds.length > 0) {
            window.__deliveryGiftEligible = true;
            window.__deliveryComplimentaryGiftVariants = giftIds.slice();
          } else {
            window.__deliveryGiftEligible = false;
            window.__deliveryComplimentaryGiftVariants = [];
          }

          if (freeTextEl) {
            const daysStr = maxDays > 0 ? String(maxDays) : (expectedDeliveryDate || '-');
            freeTextEl.textContent = 'Enjoy FREE within ' + daysStr + ' days delivery on ' + toPincode;
            freeTextEl.style.display = 'block';
          }

          checkBtn.textContent = 'Clear';
        } catch (err) {
          let msg = err.message || 'Could not check delivery. Please try again.';
          if (err.name === 'TypeError' && err.message.includes('Failed to fetch')) {
            msg = 'Could not connect to delivery API. If you see a CORS error in the console, the API may need to be accessed via a proxy.';
          }
          showError(msg);
        } finally {
          checkBtn.disabled = false;
          if (checkBtn.textContent !== 'Clear') {
            checkBtn.textContent = 'Check Now';
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryServices);
  } else {
    initDeliveryServices();
  }

  document.addEventListener('shopify:section:load', initDeliveryServices);
})();
